import styled from "styled-components";

interface ButtonProps {
  primary?: boolean;
}
export const BaseButton = styled.button<ButtonProps>`
  background: ${(p) => (p.primary ? "#333333" : "none")};
  border: 1px solid #848484;
  color: ${(p) => (p.primary ? "#ffffff" : "#444444")};

  :disabled {
    background: ${(p) => (p.primary ? "#888888" : "none")};
    color: #cccccc;
  }
`;
